import { useFilterInitialization } from './hooks/useFilterInitialization';
import { useFilters } from '../FilterContext';

export const ViewToggleFilter = () => {
	const { initialValues } = useFilters();

	// Initialize viewToggle using the generic useFilterInitialization hook
	useFilterInitialization('viewToggle', [], {
		getDefaultValue: () => {
			// Check if there's an initial value from URL/localStorage (handled by FilterContext)
			const storedView = initialValues.viewToggle;
			
			if (storedView && (storedView === 'table' || storedView === 'gantt')) {
				return {
					id: storedView,
					name: storedView === 'table' ? 'Table View' : 'Gantt View'
				};
			}
			
			// Default to table view
			return { id: 'table', name: 'Table View' };
		},
		getParams: (viewOption) => {
			// Return the view type for API or other consumers
			return { view: viewOption.id || 'table' };
		},
		waitForData: false, // Don't wait for dataSource since view is completely static
	});

	// This is a pseudo-filter that doesn't render anything
	return null;
}; 